<section class="team-directory">
  <div class="message error" *ngIf="errorMessage">{{ errorMessage }}</div>

  <section class="directory-panel">
    <div class="panel-header">
      <div>
        <h1>Команды</h1>
        <span *ngIf="loading">Обновляем данные...</span>
        <span *ngIf="!loading">{{ teams.length }} команд</span>
      </div>
      <a class="action-button primary" routerLink="/dashboard/teams/new">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5v14"/><path d="M5 12h14"/></svg>
        <span>Добавить команду</span>
      </a>
    </div>

    <div class="teams-table-wrap" *ngIf="teams.length > 0; else emptyTeams">
      <table class="teams-table">
        <thead>
          <tr>
            <th><button type="button" (click)="setSort('name')" [attr.aria-sort]="sortState('name')">Команда</button></th>
            <th><button type="button" (click)="setSort('championship')" [attr.aria-sort]="sortState('championship')">Чемпионат</button></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let team of sortedTeams; trackBy: trackById" [routerLink]="['/dashboard/teams', team.slug || team.id]">
            <td>
              <div class="team-cell">
                <span class="team-logo" [style.background-image]="getLogoBackground(team)">{{ team.logoUrl ? '' : team.name.charAt(0) }}</span>
                <strong>{{ team.name }}</strong>
              </div>
            </td>
            <td>
              <div class="championship-cell">
                <span class="championship-logo" [style.background-image]="getChampionshipLogo(team)">{{ getChampionshipLogo(team) ? '' : team.championship.charAt(0) }}</span>
                <span>{{ team.championship }}</span>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <ng-template #emptyTeams>
      <div class="empty-state">Команды пока не добавлены.</div>
    </ng-template>
  </section>
</section>
